import React from 'react';
import { connect } from 'react-redux';
import { fetchAverageTimeToCompleteData, attaFilterSelected } from '../../../actions/analytics/isiAnywhere/averageTimeToApprove';
import { Chart } from 'chart.js/auto';
import { useRef } from 'react';
import { Bar, getElementsAtEvent } from 'react-chartjs-2';
import { withOktaAuth } from '@okta/okta-react';

class AvgCompletionGraph extends React.Component {

    constructor(props) {
        super(props);

        this.chartRef = React.createRef();
    }

    getInitialGraphData = async () => {

        if (this.props.authState.isAuthenticated) {
            let authObj = {};
            const userInfo = await this.props.oktaAuth.getUser();
            //console.log("USER INFO", userInfo);
            authObj.curUserInfo = userInfo;
            authObj.token = this.props.authState.accessToken;
            //Action to check if user has analytics access
            console.log("Getting ATTA Data.");
            await this.props.fetchAverageTimeToCompleteData(authObj.token);

        }
    }

    componentDidMount() {
        //call initial fetch data only when there is no user object
        // if(Object.keys(this.props.user).length === 0){
        //     this.getUserDetails();
        // }
        //this.props.fetchActivityGraphData();
        if (Object.keys(this.props.user).length === 0) {
            this.getInitialGraphData();
        }
    }


    onClickBar = (event) => {
        console.log("Clicked the ATTA Bar Graph");
        // console.log(getElementsAtEvent(this.chartRef.current, event))
        // let clickedBar = getElementsAtEvent(this.chartRef.current, event);
        // if (clickedBar.length > 0) {
        //     let barIndex = clickedBar[0].index;
        //     let newCounts = [];
        //     let newLabels = [];
        //     if (this.props.analytics.curType === "year") {
        //         console.log("Bar Index TEST:", this.props.analytics.dailyCounts[0]);
        //         newCounts = this.props.analytics.dailyCounts[barIndex]; //this one
        //         newLabels = this.props.analytics.allDayLabels[barIndex];
        //         console.log("COUNTS TEST: ", newCounts);
        //         console.log("LABEL TEST: ", newCounts);

        //     }
        //     else {
        //         newCounts = this.props.analytics.yearCounts;
        //         newLabels = this.props.analytics.allYearLabels;
        //         console.log("COUNTS TEST: ", newCounts);
        //     }

        //     //monthIndex, graphTitle, curDataType, curCounts, yearCounts, allMonthCounts, curLabels, yearLabels, dayLabels

        //     this.props.fetchMonthGraphData2(
        //         barIndex,
        //         "clicksBar",
        //         this.props.analytics.curType,
        //         newCounts,
        //         this.props.analytics.yearCounts,
        //         this.props.analytics.dailyCounts,
        //         newLabels,
        //         this.props.analytics.allYearLabels,
        //         this.props.analytics.allDayLabels
        //     );
        // }
        // else {
        //     //this.props.fetchClicksGraphData();
        //     this.props.fetchMonthGraphData2(
        //         0,
        //         "clicksBar",
        //         "default",
        //         this.props.analytics.yearCounts,
        //         this.props.analytics.yearCounts,
        //         this.props.analytics.dailyCounts,
        //         this.props.analytics.allYearLabels,
        //         this.props.analytics.allYearLabels,
        //         this.props.analytics.allDayLabels
        //     );
        // }

    }
    // onClick = (event) => {
    //     console.log("Clicked the Activity Bar Graph");
    //     console.log(getElementsAtEvent(this.chartRef.current, event));
    //     let clickedBar = getElementsAtEvent(this.chartRef.current, event);
    //     if (clickedBar.length > 0) {
    //         let barIndex = clickedBar[0].index;
    //         this.props.fetchMonthGraphData(barIndex, "clicksBar", this.props.analytics.curType);
    //     }
    //     else {
    //         this.props.fetchActivityGraphData();
    //     }

    // }

    onClickFilter = async (event) => {
        console.log("ATTA Filter Clicked: ", event.target.innerText);
        await this.props.attaFilterSelected(event.target.innerText);

    }

    render() {
        console.log("TEST ATTA!!!! ", this.props.analytics);
        let curFilter = this.props.attaFilter;
        let curCountsTest = [];
        let curLabelsTest = [];
        if (curFilter === "Last 30 Days" && !this.props.isLoading) {
            curCountsTest = this.props.analytics.approvalTimes30Days.map(item => item.totalAverageTimeToApprove);
            curLabelsTest = this.props.analytics.approvalTimes30Days.map(item => item.appName);
            console.log("TEST ATTA I AM IN HERE!!! ", curCountsTest, curLabelsTest);
        }
        else if (curFilter === "Last Day" && !this.props.isLoading) {
            curCountsTest = this.props.analytics.approvalTimes1Day.map(item => item.totalAverageTimeToApprove);
            curLabelsTest = this.props.analytics.approvalTimes1Day.map(item => item.appName);
        }
        else if (curFilter === "Last 180 Days" && !this.props.isLoading) {
            curCountsTest = this.props.analytics.approvalTimes180Days.map(item => item.totalAverageTimeToApprove);
            curLabelsTest = this.props.analytics.approvalTimes180Days.map(item => item.appName);
        }
        // const counts = this.props.analytics.approvalTimes30days.map(item => item.count);
        // const labels = this.props.analytics.approvalTimes30days.map(item => item.label);
        //const curCounts = ["2", "5", "1", "1", "5", "6", "2", "4", "3", "8", "5", "2", "9", "5", "1", "2", "1"];
        /* const curLabels = ["Agile", "HelpNow", "RCE", "Neputne MT", "Neptune PS", "SmartRecruiters",
            "Fieldglass", "Ivalua", "MES", "SAPQN", "SAM", "Trackwise", "IT Timesheet", "Coupa", "My HCM", "Concur",
            "Adobe Sign"]; */
        //const chartRef = useRef();
        const data = {
            options: {
                legend: {
                    display: '',
                },
            },
            labels: curLabelsTest,
            datasets: [
                {
                    type: 'bar',
                    label: 'Average approval time to complete',
                    data: curCountsTest,
                    backgroundColor: 'rgba(28,35,186)',
                    borderColor: 'rgba(28,35,186)',
                    borderWidth: 1
                },
            ]
        };
        const chartOptions = {
            scales: {
                y: {
                    title: {
                        display: true,
                        text: 'Days'
                    }
                },
                x: {
                    title: {
                        display: true,
                        text: 'Applications'
                    }
                }
            },
            plugins: {
                title: {
                    display: false,
                    text: 'Based on last 3 months approvals'
                },
                legend: {
                    display: false,
                },
                datalabels: {
                    display: true,
                    color: 'black',
                    anchor: 'end',
                    align: 'top',
                    padding: {
                        top: 1,
                        bottom: 3,
                    },
                    formatter: (value) => value,
                }
            }
        }

        return (
            <div className='card'>
                <div className='card-header'>
                    {/* <div className='card-title'>Average Approval Time</div> */}
                    <div class="card-head-row">
                        <div class="card-title">Average Approval Time</div>
                        <div class="card-tools">
                            <ul class="nav nav-pills nav-secondary nav-pills-no-bd nav-sm" id="pills-tab" role="tablist">
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link intuitive-pill" id="pills-today" data-toggle="pill" href="#pills-today" role="tab" aria-selected="false" >Last Day</a>
                                </li>
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link active show" id="pills-week" data-toggle="pill" href="#pills-week" role="tab" aria-selected="true" >Last 30 Days</a>
                                </li>
                                <li class="nav-item submenu" onClick={this.onClickFilter}>
                                    <a class="nav-link" id="pills-month" data-toggle="pill" href="#pills-month" role="tab" aria-selected="false">Last 180 Days</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='chart-container'>
                        {/* <AvgCompletionGraph /> */}
                        <div>
                            {
                                this.props.isLoading ? <div class="loader loader-primary"></div> :
                                    <Bar
                                        ref={this.chartRef}
                                        data={data}
                                        onClick={this.onClickBar}
                                        options={chartOptions}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    console.log("State ATTA Bar Graph:", state);
    return { user: state.user, analytics: state.avgTimeToApproveAnalytics, isLoading: state.attaGraphIsLoading, attaFilter: state.selectedAttaFilter };
}

export default connect(mapStateToProps, { fetchAverageTimeToCompleteData, attaFilterSelected })(withOktaAuth(AvgCompletionGraph));